/**
 * Who this tab is signed in as, for state that outlives a page load.
 *
 * A parked message and a held-back delivery receipt both survive a reload in
 * sessionStorage, and a session that expired never runs logout. If someone
 * else signs in on the same tab, the first person's message must not send as
 * theirs, and the first person's receipt must not be filed under their
 * session. The stored profile is rewritten on every profile load and cleared
 * on logout, so it names whoever this tab is acting for now.
 */

import LocalStorageKey from '@enums/LocalStorageKey';
import LocalStorageService from '@services/LocalStorageService';

export function currentUserPin(): string | undefined {
  try {
    const profile = LocalStorageService.getItem<{ userId?: string }>(LocalStorageKey.USER_PROFILE);
    const userId = String(profile?.userId ?? '').trim();
    return userId || undefined;
  } catch {
    return undefined;
  }
}
